import HomeCard from "./HomeCard";
import styled from "styled-components";
import { Link } from "react-router-dom";
import chairmanImage from "../../resources/images/profiles/hq/정운기회장님3-removebg.png";
import markImage from "../../resources/images/logo/aone_logo_only.png";
import { useArticles, useBriefing } from "../hooks/useArticles";
import { SECTIONS, highlights } from "../../pages/board/BriefingPage";
import { languageStore } from "../../state/language";
import SectionHead from "../ui/common/SectionHead";

// 썸네일은 스톡 사진 대신 자사 이미지: 칼럼은 정운기 회장 사진(얼굴 쪽 확대), 에이원 소식은 로고 마크
const columnThumb = { image: chairmanImage, imageStyle: { backgroundSize: "170%", backgroundPosition: "center 21%" } };
const markThumb = { image: markImage, imageStyle: { backgroundSize: "62%" } };

// A-One 소식 API가 비었을 때(로딩 중·호출 실패) 보여줄 고정 글
const fallbackNews = [
  { category: "에이원 소식", title: "정운기 관세동우회장, ‘2023 HDI 인간경영대상’ 수상", author: "관세법인 에이원", link: "/boards/aonenews/6", date: "2024-01-05", ...markThumb },
  { category: "에이원 소식", title: "2023년 관세평가 품목분류 연구논문 분야 각각 수상", author: "관세법인 에이원", link: "/boards/aonenews/5", date: "2024-01-05", ...markThumb },
];

const HomeTab = () => {
  const { language } = languageStore();
  const briefing = highlights(useBriefing()); // 브리핑 페이지의 '오늘의 핵심'과 같은 3건
  const columnlist = useArticles("ceocolumn");
  const aonenewslist = useArticles("aonenews");

  // A-One 소식: 정운기 칼럼 최신 2건 + 에이원 소식 최신 1건 ('공고' 글은 홈에 올리지 않는다)
  const latestColumn = [...columnlist].sort((a, b) => b.no - a.no).slice(0, 2)
    .map((a) => ({ category: "정운기 칼럼", title: a.title, author: "정운기 회장", link: `/boards/ceocolumn/${a.no}`, date: a.date, ...columnThumb }));
  const latestNews = aonenewslist.filter((a) => !/공고/.test(a.title || "")).sort((a, b) => b.no - a.no).slice(0, latestColumn.length ? 1 : 3)
    .map((a) => ({ category: "에이원 소식", title: a.title, author: a.author || "관세법인 에이원", link: `/boards/aonenews/${a.no}`, date: a.date, ...markThumb }));
  const aoneNews = [...latestColumn, ...(latestNews.length ? latestNews : fallbackNews)].slice(0, 3);

  return (
    <Section>
      <div className="inner">
        <div className="col">
          <SectionHead
            eyebrow="Today's Briefing"
            title={language === "EN" ? "Today's Briefing" : "오늘의 브리핑"}
            desc="관세·통상 주요 동향을 정리합니다"
            more={<Link to="/boards/briefing">브리핑 전체 보기 →</Link>}
          />
          <ul>
            {briefing.map((it, idx) => (
              <li key={it.url}>
                <HomeCard index={idx} content={{ category: SECTIONS[it.section], title: it.title, author: it.source, link: it.url, date: it.date }} />
              </li>
            ))}
          </ul>
        </div>
        <div className="col">
          <SectionHead
            eyebrow="What's new?"
            title={language === "EN" ? "A-One News" : "A-One 소식"}
            desc="에이원의 새 소식과 구성원의 기고문"
            more={<Link to="/boards/aonenews">전체 보기 →</Link>}
          />
          <ul>
            {aoneNews.map((news) => (
              <li key={news.link}>
                <HomeCard content={news} />
              </li>
            ))}
          </ul>
        </div>
      </div>
    </Section>
  );
};
export default HomeTab;
const Section = styled.section`
  background-color: white;
  & > .inner {
    max-width: ${({ theme }) => theme.layout.content};
    margin: 0 auto;
    padding: clamp(3.5rem, 7vw, 6rem) clamp(1.25rem, 4vw, 2.5rem);
    box-sizing: border-box;
    display: grid;
    grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
    gap: 4rem;
    @media (max-width: 991px) {
      grid-template-columns: minmax(0, 1fr);
      gap: 3.5rem;
    }
  }
  & .col > ul {
    list-style: none;
    margin: 0;
    padding: 0;
    border-top: 2px solid ${({ theme }) => theme.colors.dark};
    min-height: 12rem;
  }
`;
